import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import tempTable from "@/components/rw/tempTable/index";
import tempSearch from "@/components/rw/tempSearch/index";
import tempForm from "@/components/rw/tempForm/index";
import tempChart from "@/components/rw/tempChart/index";
import { memberCompanyAdd, memberCompanyList } from '@/api/apis';
import fa from 'element-ui/src/locale/lang/fa';
export default {
  components: {
    tempTable: tempTable,
    tempSearch: tempSearch,
    tempForm: tempForm,
    tempChart: tempChart
  },
  data: function data() {
    var _this = this;

    return {
      name: "memberExamine",
      searchModel_1000: {
        "del": false,
        "id": "id_1000",
        "isCollapse": false,
        "operateData": [{
          "icon": "el-icon-search",
          "tag": "search",
          "title": "搜索",
          "type": "primary"
        }, {
          "icon": "el-icon-position",
          "tag": "export",
          "title": "导出",
          "type": "primary"
        }],
        "searchData": [{
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "0"
            }],
            "title": "待审核",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "1"
            }],
            "title": "审核通过",
            "type": "button"
          }, {
            "field": [{
              "key": "status",
              "value": "-1"
            }],
            "title": "审核拒绝",
            "total": 0,
            "type": "button"
          }],
          "id": 0,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "条件名称",
          "type": 0,
          "remoteFunc": []
        }, {
          "children": [{
            "field": [],
            "title": "全部",
            "type": "button"
          }, {
            "field": [],
            "title": "今天",
            "type": "button"
          }, {
            "field": [],
            "title": "昨天",
            "type": "button"
          }, {
            "field": [],
            "title": "最近7天",
            "type": "button"
          }, {
            "field": [],
            "title": "本月",
            "type": "button"
          }, {
            "field": [],
            "title": "本年",
            "type": "button"
          }, {
            "field": [],
            "title": "自定义",
            "type": "custom-datetime-range"
          }],
          "id": 1,
          "relation": false,
          "relationId": "",
          "remote": true,
          "remoteType": 1,
          "select": 0,
          "title": "申请日期",
          "type": 1,
          "remoteFunc": ["modelConditionFunc_1"]
        }, {
          "children": [{
            "field": [{
              "desc": "用户编号",
              "key": "user_number",
              "value": ""
            }],
            "operator": ["gte", "lte", "gt", "lt", "eq", "ne", "like", "notLike", "in", "between"],
            "placeholder": "请输入",
            "type": "input-complex"
          }],
          "id": 2,
          "relation": false,
          "relationId": "",
          "remote": false,
          "remoteType": 0,
          "select": 0,
          "title": "按条件",
          "type": 2,
          "remoteFunc": []
        }],
        "type": "searchTemplate"
      },
      tableModel_1001: {
        "border": true,
        "del": false,
        "headerButton": [{
          "icon": "",
          "id": "",
          "tag": "add",
          "title": "添加",
          "type": "primary"
        }],
        "id": "id_1001",
        "isGroup": true,
        "isTree": false,
        "rowButton": [{
          "id": "",
          "tag": "default",
          "title": "审核通过",
          "type": "success"
        }, {
          "icon": "",
          "id": "",
          "tag": "default",
          "title": "审核拒绝",
          "type": "danger"
        }, {
          "icon": "",
          "id": "",
          "tag": "edit",
          "title": "资料修改",
          "type": "primary"
        }],
        "showPagination": true,
        "showSelection": false,
        "showSummary": false,
        "stripe": true,
        "tableAutocompleteProps": {},
        "tableCascaderProps": {},
        "tableFileProps": {},
        "tableGroupProps": [{
          "id": 9,
          "name": "营业执照"
        }, {
          "id": 10,
          "name": "法人信息"
        }, {
          "id": 11,
          "name": "开户行信息"
        }, {
          "id": 15,
          "name": "委托书管理"
        }],
        "tableModel": [{
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 1,
          "groupId": "9",
          "label": "用户编号",
          "required": 1,
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "90",
          "prop": "user_number"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "7",
          "label": "申请日期",
          "required": 1,
          "rules": [],
          "show": 1,
          "type": "datetime",
          "width": "90",
          "prop": "created_at"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "7",
          "label": "状态",
          "required": 0,
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "80",
          "prop": "status"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "建议尺寸640x320 不超过256kb",
          "detail": 0,
          "excel": 0,
          "groupId": "9",
          "label": "营业执照",
          "rules": [],
          "show": 0,
          "type": "image",
          "width": "90",
          "prop": "business_pic",
          "file": {
            "checkSize": 0,
            "exData": {
              "type": "default"
            },
            "fileType": ".png,.jpg,.jpeg",
            "height": 320,
            "id": 3,
            "key": "business_pic",
            "maxNum": 1,
            "maxSize": 256,
            "width": 640
          }
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "11",
          "label": "开户行账号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "bank_account_no"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "11",
          "label": "银行名称",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "parent_bank_name"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "11",
          "label": "支行名称",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "150",
          "prop": "bank_name"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "公司名称",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "company_name"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "执照编号",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "company_no"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "9",
          "label": "营业范围",
          "rules": [],
          "show": 0,
          "type": "textarea",
          "width": "200",
          "prop": "business_scope"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "注册日期有效日期",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "160",
          "prop": "business_term"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "公司类型",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "business_type"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "公司地址",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "300",
          "prop": "company_address"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "10",
          "label": "法人姓名",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "80",
          "prop": "legal_representative"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "10",
          "label": "法人身份证号码",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "120",
          "prop": "legal_idcard"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "10",
          "label": "法人身份证姓名",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "120",
          "prop": "legal_idcard_name"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "7",
          "label": "法人身份证有效期开始",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "150",
          "prop": "legal_valid_from"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "10",
          "label": "法人身份证有效期截止",
          "rules": [],
          "show": 0,
          "type": "textarea",
          "width": "150",
          "prop": "legal_valid_to"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "10",
          "label": "法人身份证签发机关",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "150",
          "prop": "legal_idcard_issue"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "建议尺寸640x320 不超过256kb",
          "detail": 0,
          "excel": 0,
          "groupId": "10",
          "label": "法人身份证照片(正面)",
          "rules": [],
          "show": 0,
          "type": "image",
          "width": "140",
          "prop": "legal_idcard_pic",
          "file": {
            "checkSize": 0,
            "exData": {
              "type": "default"
            },
            "fileType": ".png,.jpg,.jpeg",
            "height": 320,
            "id": 5,
            "key": "legal_idcard_pic",
            "maxNum": 1,
            "maxSize": 256,
            "width": 640
          }
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "建议尺寸640x320 不超过256kb",
          "detail": 0,
          "excel": 0,
          "groupId": "10",
          "label": "法人身份证照片(反面)",
          "rules": [],
          "show": 0,
          "type": "image",
          "width": "140",
          "prop": "legal_idcard_pic_f",
          "file": {
            "checkSize": 0,
            "exData": {
              "type": "default"
            },
            "fileType": ".png,.jpg,.jpeg",
            "height": 320,
            "id": 6,
            "key": "legal_idcard_pic_f",
            "maxNum": 1,
            "maxSize": 256,
            "width": 640
          }
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "10",
          "label": "法人身份证地址",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "120",
          "prop": "legal_idcard_address"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "10",
          "label": "法人种族",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "90",
          "prop": "legal_idcard_ethnicity"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 0,
          "excel": 0,
          "groupId": "10",
          "label": "法人性别",
          "rules": [],
          "show": 0,
          "type": "text",
          "width": "90",
          "prop": "legal_sex"
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "7",
          "label": "备注信息",
          "rules": [],
          "show": 1,
          "type": "textarea",
          "width": "150",
          "prop": "remark"
        }, {
          "add": 1,
          "desc": "建议尺寸640x320 不超过256kb",
          "detail": 1,
          "excel": 1,
          "groupId": "15",
          "label": "委托书",
          "rules": [],
          "show": 1,
          "type": "image",
          "width": null,
          "prop": "contract_pic",
          "file": {
            "checkSize": 0,
            "exData": {
              "type": "default"
            },
            "fileType": ".png,.jpg,.jpeg",
            "height": 320,
            "id": 16,
            "key": "contract_pic",
            "maxNum": 1,
            "maxSize": 256,
            "width": 640
          }
        }, {
          "add": 1,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "7",
          "label": "拒绝原因",
          "rules": [],
          "show": 1,
          "type": "textarea",
          "width": "100",
          "prop": "reject_reason"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "7",
          "label": "审核人",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": null,
          "prop": "audit_user"
        }, {
          "add": 0,
          "defaultValue": null,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "7",
          "label": "审核时间",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "160",
          "prop": "audit_time"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "公司通联账户",
          "rules": [],
          "show": 1,
          "type": "text",
          "width": "100",
          "prop": "biz_user_id"
        }, {
          "add": 1,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "主体类型",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "100",
          "prop": "comproperty"
        }, {
          "add": 0,
          "desc": "",
          "detail": 1,
          "excel": 1,
          "groupId": "9",
          "label": "是否签约",
          "rules": [],
          "show": 1,
          "type": "select",
          "width": "100",
          "prop": "is_sign_contract"
        }],
        "tableName": "",
        "tableRadioProps": {},
        "tableSelectProps": {
          "status": {
            "data": [{
              "key": 0,
              "value": "待审核"
            }, {
              "key": 1,
              "value": "审核通过"
            }, {
              "key": -1,
              "value": "审核拒绝"
            }],
            "id": 1,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "comproperty": {
            "data": [{
              "key": 1,
              "value": "企业"
            }, {
              "key": 2,
              "value": "个体工商户"
            }],
            "id": 17,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          },
          "is_sign_contract": {
            "data": [{
              "key": 0,
              "value": "否"
            }, {
              "key": 1,
              "value": "是"
            }],
            "id": 18,
            "multiple": 0,
            "relation": false,
            "relationProps": [],
            "remote": false
          }
        },
        "tableSwitchProps": {},
        "title": "区域申请",
        "type": "tableTemplate"
      },
      remoteFunc: {
        modelConditionFunc_1: function modelConditionFunc_1(tag, relationData, resolve) {
          //筛选条件数据
          //[[{key:"type",value:"1"}]]
          var data = [];
          data = [[{
            key: "add_time",
            value: []
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 0, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 1, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 7, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 30, true)
          }], [{
            key: "add_time",
            value: _this.$g.fun.getDateRange(new Date(), 365, true)
          }], [{
            key: "add_time",
            value: []
          }]];
          resolve(tag, data);
        }
      }
    };
  },
  mounted: function mounted() {
    this.table = this.$refs.ref_1001;
    this.search = this.$refs.ref_1000;
  },
  methods: {
    reqTableData: function reqTableData(params, resolve) {
      var where = {};

      if (this.search) {
        where = this.search.parseWhere();
        params.where = where;
      }

      memberCompanyList(params).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resolve({
                  total: res.count,
                  data: res.rows
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    },
    reqAdd: function reqAdd(isEdit, params, row, resolve) {
      if (isEdit) {
        params.user_number = row.user_number;
      }

      memberCompanyAdd(params).then(function _callee2(res) {
        return regeneratorRuntime.async(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                resolve();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        });
      });
    },
    reqDel: function reqDel(params, resolve) {
      var ids = params.map(function (item) {
        return item.id;
      }); //xxxDel({id:ids}).then(async res=>{
      //  resolve()
      //})
    },
    onClickLink: function onClickLink(prop, row) {//点击列表link类型回调
    },
    onClickRowButton: function onClickRowButton(btnIndex, row) {
      var _this2 = this;

      //点击列表按钮回调
      if (btnIndex == 0) {
        this.$confirm('确定执行此操作？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          memberCompanyAdd({
            user_number: row.user_number,
            status: 1
          }).then(function _callee3(res) {
            return regeneratorRuntime.async(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this2.$alert('审核通过', '提示', {
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this2.table.reloadData();
                      }
                    });

                  case 1:
                  case "end":
                    return _context3.stop();
                }
              }
            });
          });
        });
      } else if (btnIndex == 1) {
        this.$prompt('请输入拒绝原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function (_ref) {
          var value = _ref.value;
          memberCompanyAdd({
            user_number: row.user_number,
            status: -1,
            reject_reason: value
          }).then(function _callee4(res) {
            return regeneratorRuntime.async(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _this2.$alert('拒绝成功', '提示', {
                      confirmButtonText: '确定',
                      callback: function callback(action) {
                        _this2.table.reloadData();
                      }
                    });

                  case 1:
                  case "end":
                    return _context4.stop();
                }
              }
            });
          });
        });
      }
    },
    onClickHeaderButton: function onClickHeaderButton(btnIndex, row) {//点击列表头部按钮回调
    },
    onSummary: function onSummary(param) {//列表尾部合计回调
    },
    onSwitchChange: function onSwitchChange(val, prop, row) {//列表中switch变化事件
    },
    onClickSearchOperate: function onClickSearchOperate(btnIndex, btnData) {
      //条件菜单按钮点击事件
      if (btnData.tag === this.$tempModel.buttonTag.search) {
        this.table.reloadData();
      } else if (btnData.tag === this.$tempModel.buttonTag.export) {
        this.table.exportExcel();
      } else if (btnData.tag === this.$tempModel.buttonTag.import) {
        var header = btnData.header;
        var results = btnData.results;
      }
    },
    onConditionChange: function onConditionChange(tag, index) {
      this.table.reloadData();
    },
    onRowButtonShow: function onRowButtonShow(btnIndex, row) {
      if (btnIndex == 0 || btnIndex == 1) {
        if (row.status != 0) {
          return false;
        }
      }

      return true;
    }
  }
};